import { forwardRef, useCallback, useMemo } from "react";

import classNames from "classnames";

import { useTranslation } from "react-i18next";

import Select, { components } from "react-select";

import { isEmpty } from "../../utils/validators";

const SelectField = forwardRef((props, ref) => {
  const {
    id,
    name,
    autoComplete,
    label,
    disabled,
    options,
    required,
    error,
    menuPortalTarget,
    ...rest
  } = props;

  const { t } = useTranslation();

  const labelMemo = useMemo(() => {
    const reqLabel = required ? "*" : "";
    return [label, reqLabel].filter((i) => !isEmpty(i)).join(" ");
  }, [label, required]);

  const NoOptionsMessage = (props) => {
    return t("placeholder.empty_list");
  };

  const LoadingMessage = (props) => {
    return t("placeholder.loading");
  };

  const onMenuOpenHandler = useCallback((evt) => {
    setTimeout(() => {
      const selectedEl = document.getElementsByClassName(
        "select-field__option--is-selected"
      )[0];
      if (selectedEl) {
        selectedEl.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "start",
        });
      }
    }, 15);
  }, []);

  const Input = (props) => {
    const { selectProps } = props;
    const { autoComplete } = selectProps;

    return (
      <components.Input
        {...props}
        id={id}
        name={name}
        autoComplete={autoComplete}
      />
    );
  };

  return (
    <div className="select-field__container">
      <div
        className={classNames("select-field__content", {
          disabled: disabled,
          invalid: error,
        })}
      >
        <label htmlFor={name} className="select-field__label" title={labelMemo}>
          {labelMemo}
        </label>
        <Select
          {...rest}
          ref={ref}
          autoComplete={autoComplete}
          options={options}
          disabled={disabled}
          required={required}
          classNamePrefix="select-field"
          className={classNames("select-field__input", { disabled: disabled })}
          loadingMessage={(obj) => <LoadingMessage obj={obj} />}
          noOptionsMessage={(obj) => <NoOptionsMessage obj={obj} />}
          minMenuHeight={100}
          maxMenuHeight={200}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          menuPosition="fixed"
          closeMenuOnScroll={true}
          menuShouldScrollIntoView={true}
          openMenuOnClick={true}
          openMenuOnFocus={true}
          closeMenuOnSelect={true}
          onMenuOpen={(evt) => onMenuOpenHandler(evt)}
          components={{
            Input,
          }}
        />
      </div>
      <p
        className={classNames("select-field__error", {
          show: error,
        })}
      >
        {error}
      </p>
    </div>
  );
});

export default SelectField;
